/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CatalogDotDotDotDotCatalogRoutesRouteRouteImport } from './catalog/routes/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StaffIndexRouteImport } from './routes/staff/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ProexpertDotDotDotDotProexpertRoutesIndexRouteImport } from './proexpert/routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as CatalogDotDotDotDotCatalogRoutesIndexRouteImport } from './catalog/routes/index'
import { Route as ProexpertDotDotDotDotProexpertRoutesDashboardRouteImport } from './proexpert/routes/dashboard'
import { Route as CatalogDotDotDotDotCatalogRoutesTaxonomyRouteImport } from './catalog/routes/taxonomy'
import { Route as CatalogDotDotDotDotCatalogRoutesSplatRouteImport } from './catalog/routes/$'
import { Route as CatalogDotDotDotDotCatalogRoutesImportRouteRouteImport } from './catalog/routes/import/route'
import { Route as adminCompaniesRouteRouteImport } from './routes/(admin)/companies/route'
import { Route as CatalogDotDotDotDotCatalogRoutesImportIndexRouteImport } from './catalog/routes/import/index'
import { Route as adminUsersIndexRouteImport } from './routes/(admin)/users/index'
import { Route as adminOrganizationsIndexRouteImport } from './routes/(admin)/organizations/index'
import { Route as adminCompaniesIndexRouteImport } from './routes/(admin)/companies/index'
import { Route as CatalogDotDotDotDotCatalogRoutesImportAddRouteImport } from './catalog/routes/import/add'
import { Route as CatalogDotDotDotDotCatalogRoutesImportIdRouteImport } from './catalog/routes/import/$id'
import { Route as adminCompaniesIdRouteImport } from './routes/(admin)/companies/$id'

const CatalogDotDotDotDotCatalogRoutesRouteRoute =
  CatalogDotDotDotDotCatalogRoutesRouteRouteImport.update({
    id: '/catalog',
    path: '/catalog',
    getParentRoute: () => rootRouteImport,
  } as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffIndexRoute = StaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProexpertDotDotDotDotProexpertRoutesIndexRoute =
  ProexpertDotDotDotDotProexpertRoutesIndexRouteImport.update({
    id: '/proexpert/',
    path: '/proexpert/',
    getParentRoute: () => rootRouteImport,
  } as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogDotDotDotDotCatalogRoutesIndexRoute =
  CatalogDotDotDotDotCatalogRoutesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CatalogDotDotDotDotCatalogRoutesRouteRoute,
  } as any)
const ProexpertDotDotDotDotProexpertRoutesDashboardRoute =
  ProexpertDotDotDotDotProexpertRoutesDashboardRouteImport.update({
    id: '/proexpert/dashboard',
    path: '/proexpert/dashboard',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogDotDotDotDotCatalogRoutesTaxonomyRoute =
  CatalogDotDotDotDotCatalogRoutesTaxonomyRouteImport.update({
    id: '/taxonomy',
    path: '/taxonomy',
    getParentRoute: () => CatalogDotDotDotDotCatalogRoutesRouteRoute,
  } as any)
const CatalogDotDotDotDotCatalogRoutesSplatRoute =
  CatalogDotDotDotDotCatalogRoutesSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => CatalogDotDotDotDotCatalogRoutesRouteRoute,
  } as any)
const CatalogDotDotDotDotCatalogRoutesImportRouteRoute =
  CatalogDotDotDotDotCatalogRoutesImportRouteRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => CatalogDotDotDotDotCatalogRoutesRouteRoute,
  } as any)
const adminCompaniesRouteRoute = adminCompaniesRouteRouteImport.update({
  id: '/(admin)/companies',
  path: '/companies',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogDotDotDotDotCatalogRoutesImportIndexRoute =
  CatalogDotDotDotDotCatalogRoutesImportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CatalogDotDotDotDotCatalogRoutesImportRouteRoute,
  } as any)
const adminUsersIndexRoute = adminUsersIndexRouteImport.update({
  id: '/(admin)/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const adminOrganizationsIndexRoute = adminOrganizationsIndexRouteImport.update({
  id: '/(admin)/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const adminCompaniesIndexRoute = adminCompaniesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => adminCompaniesRouteRoute,
} as any)
const CatalogDotDotDotDotCatalogRoutesImportAddRoute =
  CatalogDotDotDotDotCatalogRoutesImportAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => CatalogDotDotDotDotCatalogRoutesImportRouteRoute,
  } as any)
const CatalogDotDotDotDotCatalogRoutesImportIdRoute =
  CatalogDotDotDotDotCatalogRoutesImportIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => CatalogDotDotDotDotCatalogRoutesImportRouteRoute,
  } as any)
const adminCompaniesIdRoute = adminCompaniesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => adminCompaniesRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/catalog': typeof CatalogDotDotDotDotCatalogRoutesRouteRouteWithChildren
  '/companies': typeof adminCompaniesRouteRouteWithChildren
  '/catalog/import': typeof CatalogDotDotDotDotCatalogRoutesImportRouteRouteWithChildren
  '/catalog/$': typeof CatalogDotDotDotDotCatalogRoutesSplatRoute
  '/catalog/taxonomy': typeof CatalogDotDotDotDotCatalogRoutesTaxonomyRoute
  '/proexpert/dashboard': typeof ProexpertDotDotDotDotProexpertRoutesDashboardRoute
  '/catalog/': typeof CatalogDotDotDotDotCatalogRoutesIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login/': typeof LoginIndexRoute
  '/proexpert/': typeof ProexpertDotDotDotDotProexpertRoutesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/staff/': typeof StaffIndexRoute
  '/companies/$id': typeof adminCompaniesIdRoute
  '/catalog/import/$id': typeof CatalogDotDotDotDotCatalogRoutesImportIdRoute
  '/catalog/import/add': typeof CatalogDotDotDotDotCatalogRoutesImportAddRoute
  '/companies/': typeof adminCompaniesIndexRoute
  '/organizations/': typeof adminOrganizationsIndexRoute
  '/users/': typeof adminUsersIndexRoute
  '/catalog/import/': typeof CatalogDotDotDotDotCatalogRoutesImportIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/catalog/$': typeof CatalogDotDotDotDotCatalogRoutesSplatRoute
  '/catalog/taxonomy': typeof CatalogDotDotDotDotCatalogRoutesTaxonomyRoute
  '/proexpert/dashboard': typeof ProexpertDotDotDotDotProexpertRoutesDashboardRoute
  '/catalog': typeof CatalogDotDotDotDotCatalogRoutesIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/login': typeof LoginIndexRoute
  '/proexpert': typeof ProexpertDotDotDotDotProexpertRoutesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/staff': typeof StaffIndexRoute
  '/companies/$id': typeof adminCompaniesIdRoute
  '/catalog/import/$id': typeof CatalogDotDotDotDotCatalogRoutesImportIdRoute
  '/catalog/import/add': typeof CatalogDotDotDotDotCatalogRoutesImportAddRoute
  '/companies': typeof adminCompaniesIndexRoute
  '/organizations': typeof adminOrganizationsIndexRoute
  '/users': typeof adminUsersIndexRoute
  '/catalog/import': typeof CatalogDotDotDotDotCatalogRoutesImportIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/catalog': typeof CatalogDotDotDotDotCatalogRoutesRouteRouteWithChildren
  '/(admin)/companies': typeof adminCompaniesRouteRouteWithChildren
  '/catalog/import': typeof CatalogDotDotDotDotCatalogRoutesImportRouteRouteWithChildren
  '/catalog/$': typeof CatalogDotDotDotDotCatalogRoutesSplatRoute
  '/catalog/taxonomy': typeof CatalogDotDotDotDotCatalogRoutesTaxonomyRoute
  '/proexpert/dashboard': typeof ProexpertDotDotDotDotProexpertRoutesDashboardRoute
  '/catalog/': typeof CatalogDotDotDotDotCatalogRoutesIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login/': typeof LoginIndexRoute
  '/proexpert/': typeof ProexpertDotDotDotDotProexpertRoutesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/staff/': typeof StaffIndexRoute
  '/(admin)/companies/$id': typeof adminCompaniesIdRoute
  '/catalog/import/$id': typeof CatalogDotDotDotDotCatalogRoutesImportIdRoute
  '/catalog/import/add': typeof CatalogDotDotDotDotCatalogRoutesImportAddRoute
  '/(admin)/companies/': typeof adminCompaniesIndexRoute
  '/(admin)/organizations/': typeof adminOrganizationsIndexRoute
  '/(admin)/users/': typeof adminUsersIndexRoute
  '/catalog/import/': typeof CatalogDotDotDotDotCatalogRoutesImportIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/catalog'
    | '/companies'
    | '/catalog/import'
    | '/catalog/$'
    | '/catalog/taxonomy'
    | '/proexpert/dashboard'
    | '/catalog/'
    | '/dashboard/'
    | '/login/'
    | '/proexpert/'
    | '/settings/'
    | '/staff/'
    | '/companies/$id'
    | '/catalog/import/$id'
    | '/catalog/import/add'
    | '/companies/'
    | '/organizations/'
    | '/users/'
    | '/catalog/import/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/catalog/$'
    | '/catalog/taxonomy'
    | '/proexpert/dashboard'
    | '/catalog'
    | '/dashboard'
    | '/login'
    | '/proexpert'
    | '/settings'
    | '/staff'
    | '/companies/$id'
    | '/catalog/import/$id'
    | '/catalog/import/add'
    | '/companies'
    | '/organizations'
    | '/users'
    | '/catalog/import'
  id:
    | '__root__'
    | '/'
    | '/catalog'
    | '/(admin)/companies'
    | '/catalog/import'
    | '/catalog/$'
    | '/catalog/taxonomy'
    | '/proexpert/dashboard'
    | '/catalog/'
    | '/dashboard/'
    | '/login/'
    | '/proexpert/'
    | '/settings/'
    | '/staff/'
    | '/(admin)/companies/$id'
    | '/catalog/import/$id'
    | '/catalog/import/add'
    | '/(admin)/companies/'
    | '/(admin)/organizations/'
    | '/(admin)/users/'
    | '/catalog/import/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CatalogDotDotDotDotCatalogRoutesRouteRoute: typeof CatalogDotDotDotDotCatalogRoutesRouteRouteWithChildren
  adminCompaniesRouteRoute: typeof adminCompaniesRouteRouteWithChildren
  ProexpertDotDotDotDotProexpertRoutesDashboardRoute: typeof ProexpertDotDotDotDotProexpertRoutesDashboardRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  ProexpertDotDotDotDotProexpertRoutesIndexRoute: typeof ProexpertDotDotDotDotProexpertRoutesIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  StaffIndexRoute: typeof StaffIndexRoute
  adminOrganizationsIndexRoute: typeof adminOrganizationsIndexRoute
  adminUsersIndexRoute: typeof adminUsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogDotDotDotDotCatalogRoutesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/': {
      id: '/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof StaffIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proexpert/': {
      id: '/proexpert/'
      path: '/proexpert'
      fullPath: '/proexpert/'
      preLoaderRoute: typeof ProexpertDotDotDotDotProexpertRoutesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/': {
      id: '/catalog/'
      path: '/'
      fullPath: '/catalog/'
      preLoaderRoute: typeof CatalogDotDotDotDotCatalogRoutesIndexRouteImport
      parentRoute: typeof CatalogDotDotDotDotCatalogRoutesRouteRoute
    }
    '/proexpert/dashboard': {
      id: '/proexpert/dashboard'
      path: '/proexpert/dashboard'
      fullPath: '/proexpert/dashboard'
      preLoaderRoute: typeof ProexpertDotDotDotDotProexpertRoutesDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/taxonomy': {
      id: '/catalog/taxonomy'
      path: '/taxonomy'
      fullPath: '/catalog/taxonomy'
      preLoaderRoute: typeof CatalogDotDotDotDotCatalogRoutesTaxonomyRouteImport
      parentRoute: typeof CatalogDotDotDotDotCatalogRoutesRouteRoute
    }
    '/catalog/$': {
      id: '/catalog/$'
      path: '/$'
      fullPath: '/catalog/$'
      preLoaderRoute: typeof CatalogDotDotDotDotCatalogRoutesSplatRouteImport
      parentRoute: typeof CatalogDotDotDotDotCatalogRoutesRouteRoute
    }
    '/catalog/import': {
      id: '/catalog/import'
      path: '/import'
      fullPath: '/catalog/import'
      preLoaderRoute: typeof CatalogDotDotDotDotCatalogRoutesImportRouteRouteImport
      parentRoute: typeof CatalogDotDotDotDotCatalogRoutesRouteRoute
    }
    '/(admin)/companies': {
      id: '/(admin)/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof adminCompaniesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/import/': {
      id: '/catalog/import/'
      path: '/'
      fullPath: '/catalog/import/'
      preLoaderRoute: typeof CatalogDotDotDotDotCatalogRoutesImportIndexRouteImport
      parentRoute: typeof CatalogDotDotDotDotCatalogRoutesImportRouteRoute
    }
    '/(admin)/users/': {
      id: '/(admin)/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof adminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/organizations/': {
      id: '/(admin)/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof adminOrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/companies/': {
      id: '/(admin)/companies/'
      path: '/'
      fullPath: '/companies/'
      preLoaderRoute: typeof adminCompaniesIndexRouteImport
      parentRoute: typeof adminCompaniesRouteRoute
    }
    '/catalog/import/add': {
      id: '/catalog/import/add'
      path: '/add'
      fullPath: '/catalog/import/add'
      preLoaderRoute: typeof CatalogDotDotDotDotCatalogRoutesImportAddRouteImport
      parentRoute: typeof CatalogDotDotDotDotCatalogRoutesImportRouteRoute
    }
    '/catalog/import/$id': {
      id: '/catalog/import/$id'
      path: '/$id'
      fullPath: '/catalog/import/$id'
      preLoaderRoute: typeof CatalogDotDotDotDotCatalogRoutesImportIdRouteImport
      parentRoute: typeof CatalogDotDotDotDotCatalogRoutesImportRouteRoute
    }
    '/(admin)/companies/$id': {
      id: '/(admin)/companies/$id'
      path: '/$id'
      fullPath: '/companies/$id'
      preLoaderRoute: typeof adminCompaniesIdRouteImport
      parentRoute: typeof adminCompaniesRouteRoute
    }
  }
}

interface CatalogDotDotDotDotCatalogRoutesImportRouteRouteChildren {
  CatalogDotDotDotDotCatalogRoutesImportIdRoute: typeof CatalogDotDotDotDotCatalogRoutesImportIdRoute
  CatalogDotDotDotDotCatalogRoutesImportAddRoute: typeof CatalogDotDotDotDotCatalogRoutesImportAddRoute
  CatalogDotDotDotDotCatalogRoutesImportIndexRoute: typeof CatalogDotDotDotDotCatalogRoutesImportIndexRoute
}

const CatalogDotDotDotDotCatalogRoutesImportRouteRouteChildren: CatalogDotDotDotDotCatalogRoutesImportRouteRouteChildren =
  {
    CatalogDotDotDotDotCatalogRoutesImportIdRoute:
      CatalogDotDotDotDotCatalogRoutesImportIdRoute,
    CatalogDotDotDotDotCatalogRoutesImportAddRoute:
      CatalogDotDotDotDotCatalogRoutesImportAddRoute,
    CatalogDotDotDotDotCatalogRoutesImportIndexRoute:
      CatalogDotDotDotDotCatalogRoutesImportIndexRoute,
  }

const CatalogDotDotDotDotCatalogRoutesImportRouteRouteWithChildren =
  CatalogDotDotDotDotCatalogRoutesImportRouteRoute._addFileChildren(
    CatalogDotDotDotDotCatalogRoutesImportRouteRouteChildren,
  )

interface CatalogDotDotDotDotCatalogRoutesRouteRouteChildren {
  CatalogDotDotDotDotCatalogRoutesImportRouteRoute: typeof CatalogDotDotDotDotCatalogRoutesImportRouteRouteWithChildren
  CatalogDotDotDotDotCatalogRoutesSplatRoute: typeof CatalogDotDotDotDotCatalogRoutesSplatRoute
  CatalogDotDotDotDotCatalogRoutesTaxonomyRoute: typeof CatalogDotDotDotDotCatalogRoutesTaxonomyRoute
  CatalogDotDotDotDotCatalogRoutesIndexRoute: typeof CatalogDotDotDotDotCatalogRoutesIndexRoute
}

const CatalogDotDotDotDotCatalogRoutesRouteRouteChildren: CatalogDotDotDotDotCatalogRoutesRouteRouteChildren =
  {
    CatalogDotDotDotDotCatalogRoutesImportRouteRoute:
      CatalogDotDotDotDotCatalogRoutesImportRouteRouteWithChildren,
    CatalogDotDotDotDotCatalogRoutesSplatRoute:
      CatalogDotDotDotDotCatalogRoutesSplatRoute,
    CatalogDotDotDotDotCatalogRoutesTaxonomyRoute:
      CatalogDotDotDotDotCatalogRoutesTaxonomyRoute,
    CatalogDotDotDotDotCatalogRoutesIndexRoute:
      CatalogDotDotDotDotCatalogRoutesIndexRoute,
  }

const CatalogDotDotDotDotCatalogRoutesRouteRouteWithChildren =
  CatalogDotDotDotDotCatalogRoutesRouteRoute._addFileChildren(
    CatalogDotDotDotDotCatalogRoutesRouteRouteChildren,
  )

interface adminCompaniesRouteRouteChildren {
  adminCompaniesIdRoute: typeof adminCompaniesIdRoute
  adminCompaniesIndexRoute: typeof adminCompaniesIndexRoute
}

const adminCompaniesRouteRouteChildren: adminCompaniesRouteRouteChildren = {
  adminCompaniesIdRoute: adminCompaniesIdRoute,
  adminCompaniesIndexRoute: adminCompaniesIndexRoute,
}

const adminCompaniesRouteRouteWithChildren =
  adminCompaniesRouteRoute._addFileChildren(adminCompaniesRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CatalogDotDotDotDotCatalogRoutesRouteRoute:
    CatalogDotDotDotDotCatalogRoutesRouteRouteWithChildren,
  adminCompaniesRouteRoute: adminCompaniesRouteRouteWithChildren,
  ProexpertDotDotDotDotProexpertRoutesDashboardRoute:
    ProexpertDotDotDotDotProexpertRoutesDashboardRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  ProexpertDotDotDotDotProexpertRoutesIndexRoute:
    ProexpertDotDotDotDotProexpertRoutesIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  StaffIndexRoute: StaffIndexRoute,
  adminOrganizationsIndexRoute: adminOrganizationsIndexRoute,
  adminUsersIndexRoute: adminUsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
